export default __webpack_public_path__ + "static/AllProducts-8dfaa59cc1d7ac5bb02ace68a5037a95.webp";